






































































import { Component, Vue } from "vue-property-decorator";
import OrderModule from "@/store/order";
import UGCViewer from "@/components/UGCViewer.vue";
import { OrderDetail, Menu, OrderType } from "@/api/api";
import moment from "moment";

@Component({
  components: {
    UGCViewer,
  },
})
export default class ROrderInfo extends Vue {
  private get order() {
    return OrderModule.order;
  }

  private get moment() {
    return moment;
  }

  private get OrderType() {
    return OrderType;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private sumTotalQuantity(orderDetails: any) {
    let sum = 0;
    orderDetails.forEach((detail: OrderDetail) => {
      sum += detail?.quantity ? detail?.quantity : 0;
    });
    return sum;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private sumSubtotalPrice(orderDetails: any[]) {
    let sum = 0;
    orderDetails.forEach((detail: OrderDetail & { menu: Menu }) => {
      sum += detail.menu.price * (detail?.quantity ? detail.quantity : 0);
    });
    return sum;
  }

  private back() {
    this.$router.go(-1);
  }
}
